export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    // The dashboard lives at the platform domain root, unlike every other
    // module (which lives under its own subpath) — see App.jsx (no basename).
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    // localStorage — this is the shared session every other module's silent
    // token acquisition relies on, since they're all on the same origin in
    // production (different paths, not different origins).
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

export const apiRequest = {
  scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID}/access_as_user`],
};
